import { useMemo } from "react";
import { ILiteTradePortfolioPosition } from "../../../../modules/LiteTrade/types/liteTradeReducer.t";
import { makeSelectLiteTradeMarketDataBySymbol } from "../../../../modules/LiteTrade/liteTradeSelectors";
import { useSelector } from "react-redux";
import { type IMobileAppRootState } from "../../../types/mobileAppState.t";
import { LITE_TRADE_POSITION_SIDE } from "../../../../modules/LiteTrade/liteTradeConstants";
import { getCurrentPriceFromMarket } from "./helpers";
import type Asset from "../../../../modules/Asset/Asset";

export const useMobilePositionPL = (positionInfo: ILiteTradePortfolioPosition, assetInstance: Asset): number => {
    const symbol = positionInfo?.instrument;
    const selectLiteTradeMarketDataBySymbol = useMemo(() => makeSelectLiteTradeMarketDataBySymbol(symbol), [symbol]);
    const pnl = useSelector((state: IMobileAppRootState) => {
        const marketDataSymbol = selectLiteTradeMarketDataBySymbol(state);
        if (!positionInfo) {
            return null;
        }
        const withSpread = positionInfo?.side !== LITE_TRADE_POSITION_SIDE.BUY;
        const currentPrice = getCurrentPriceFromMarket(marketDataSymbol, withSpread);
        if (!assetInstance) {
            console.error('useMobilePositionPL Asset instance is not defined. positionInfo', positionInfo);
        }
        const pnl = assetInstance.getPositionPL(positionInfo, currentPrice);
        return pnl;
    });
    return pnl;
};